import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import {
  UpdateProspectDto,
  updateProspectService,
} from '@hc-frontend/services';

import type { UpdateProspectProductTypeRepository } from '../../domain';
import { productTypeToLeadProductType } from '../product-type-to-lead-product-type';

/**
 * Creates a Lead Storage implementation of {@link UpdateProspectProductTypeRepository}.
 *
 * @param options - `baseURL` of the Lead Storage API.
 * @returns A repository that upserts the prospect's `productTypeId`.
 */
export function updateProspectProductTypeAdapterFactory({
  baseURL,
}: {
  baseURL: string;
}): UpdateProspectProductTypeRepository {
  return {
    update: async ({ sessionId, userId, productType }) => {
      try {
        const payload: UpdateProspectDto = {
          sessionId,
          userId,
          productTypeId: productTypeToLeadProductType(productType),
        };
        const response = await updateProspectService(baseURL, payload);

        if (response.result !== 'success') {
          return createErrorOperationResult({
            errors: [
              {
                code: 'failedToUpdateProspectProductType',
                rootCause: new Error('Failed to update prospect product type'),
              },
            ],
          });
        }

        return createSuccessOperationResult(undefined);
      } catch (error) {
        return createErrorOperationResult({
          errors: [
            {
              code: 'failedToUpdateProspectProductType',
              rootCause: error as Error,
            },
          ],
        });
      }
    },
  };
}
